module.exports = __webpack_public_path__ + "static/bg_095_alice_in_wonderland-d5816dd7f68b50fbc58aebfd042f2dad.webp";